import axios from '@/services/apiAxios';
// import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    }, 
    actions: {
        fetchSimulate({ rootState, dispatch }, payload) {
            // let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: `aica/sales-invoice`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    // commit('setGroups', response.data);
                    resolve(response.data)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}